import React, { useEffect, useState } from "react";
// import Navbar from '../../landing/header/Navbar'
import Banner from "./Banner/Banner";
import Bottompage from "../Createpremiumprojects/Bottompage";
import Newfooter from "../../../Newfooter/Newfooter";

const PreviewProject = ({
  setRoutes,
  basicInfo,
  setBasicInfo,
  setProjectId,
  walletformData,
  teamFormData,
  projectSetup,
  saleRounds,
  setLoader,
  setLastUpdated,
  socialsFormData,
  nftFormData,
  currentStep,
  projectId,
  lastUpdated,
  setSocialsFormData,
  setProjectSetup,
  setChangeRoute,
  setTeamFormData,
  isLive,
  setIsLive,
  setId,
  isAvailable,
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="wrapper-detailpage">
        <Banner
          setRoutes={setRoutes}
          basicInfo={basicInfo}
          setBasicInfo={setBasicInfo}
          walletformData={walletformData}
          teamFormData={teamFormData}
          projectSetup={projectSetup}
          saleRounds={saleRounds}
          setLoader={setLoader}
          socialsFormData={socialsFormData}
          nftFormData={nftFormData}
          currentStep={currentStep}
          projectId={projectId}
          lastUpdated={lastUpdated}
          setProjectSetup={setProjectSetup}
          setSocialsFormData={setSocialsFormData}
          setTeamFormData={setTeamFormData}
          setIsLive={setIsLive}
          isLive={isLive}
        />
        <Bottompage
          setRoutes={setRoutes}
          basicInfo={basicInfo}
          walletformData={walletformData}
          teamFormData={teamFormData}
          projectSetup={projectSetup}
          saleRounds={saleRounds}
          setLastUpdated={setLastUpdated}
          setLoader={setLoader}
          socialsFormData={socialsFormData}
          nftFormData={nftFormData}
          currentStep={currentStep}
          projectId={projectId}
          lastUpdated={lastUpdated}
          isLive={isLive}
          isPreview={true}
          setId={setId}
          setChangeRoute={setChangeRoute}
          isAvailable={isAvailable}
          setProjectId={setProjectId}
        />
      </div>
    </>
  );
};

export default PreviewProject;
